var MuiList = {
// /* put your new default props here */
};
export default MuiList;
//# sourceMappingURL=MuiList.js.map